export default function infoReducer(state, action) {
  switch (action.type) {
    case 'POPULATE_CLIENTS':
      const clientsArray = [...action.payload]
      return ([
        ...clientsArray
      ])
    case 'MODIFY_CLIENT':
      const modifiedClient = {...action.modifiedClient}
      return state.map(client => {
        if (client.id.$oid === action.userId) {
          return modifiedClient
        } else {
          return client
        }
      })
    case 'MODIFY_ORDER':
      const modifiedOrder = {...action.modifiedOrder}
      return state.map(client => {
        if (client.id.$oid === action.userId) {
          client.orders = client.orders.map(order => {
            if (order.id.$oid === action.orderId) {
              return modifiedOrder
            } else {
              return order
            }
          })
          return client
        }
        else {
          return client
        }
      })
    case 'DELETE_CLIENT':
      return state.filter(client => client.id.$oid !== action.userId)
    case 'DELETE_ORDER': 
      return state.map(client => {
        if (client.id.$oid === action.userId) {
          client.orders = client.orders.filter(order => order.id.$oid !== action.orderId)
          return client
        }
        else return client;
      })
    case 'ACCEPT_ORDER':
      let found = false
      const newState = state.map(client => {
        if (client.id.$oid === action.ticket.client.id.$oid) {
          client.orders.push(action.ticket.order)
          found = true
          return client
        } else return client
      })
      if (!found) {
        action.ticket.client['orders'] = []
        action.ticket.client['orders'].push(action.ticket.order)
        newState.push(action.ticket.client)
        return newState
      } else return newState
    default:
      return state
  }
}